import React, { Fragment } from 'react';
import Header from '../../components/header3/Header3';
import PageTitle from '../../components/pagetitle/PageTitle';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Footer from '../../components/footer/Footer';
import CtaSection from '../../components/CtaSection/CtaSection';
import { BlogList } from '../../components/Blog';

const BlogPage = () => {
  return (
    <Fragment>
      <Header />
      <main className="page_content blog-page">
        <PageTitle
          pageTitle={'Insights & Articles'}
          pagesub={'Knowledge Hub'}
          pageTop={'Our'}
          bgOverride={{ background: 'linear-gradient(135deg, #fdfaf6 0%, #f5ede0 50%, #ede3d4 100%)' }}
          darkText
        />
        <BlogList />
      </main>
      <CtaSection />
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};

export default BlogPage;